import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomPipesModule } from 'src/app/pipes/custom-pipes.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { HttpTranslateFactory } from 'src/app/helpers';
import { DynamicDataListHeaderComponent } from './components/dynamic-data-list-header/dynamic-data-list-header.component';
import { DynamicDataListPaginationComponent } from './components/dynamic-data-list-pagination/dynamic-data-list-pagination.component';
import { DynamicDataListTableComponent } from './components/dynamic-data-list-table/dynamic-data-list-table.component';
import { DynamicDataListContainer } from './dynamic-data-list.container';
import { SortableColumnComponent } from './components/sortable-column/sortable-column.component';
import { DynamicDataListCsvComponent } from './components/dynamic-data-list-csv/dynamic-data-list-csv.component';

@NgModule({
  declarations: [
    DynamicDataListHeaderComponent,
    DynamicDataListPaginationComponent,
    DynamicDataListTableComponent,
    DynamicDataListContainer,
    DynamicDataListCsvComponent,
    SortableColumnComponent,
  ],
  imports: [
    CommonModule,
    NgbPaginationModule,
    CustomPipesModule,
    TranslateModule.forChild({
      loader: {
        deps: [HttpClient],
        provide: TranslateLoader,
        useFactory: HttpTranslateFactory,
      },
    }),
  ],
  exports: [DynamicDataListContainer, SortableColumnComponent, DynamicDataListCsvComponent],
})
export class DynamicDataListModule {}
